export const urlObj = {
  referrer: {
    // url: document?.referrer,
    conditions: ['/signup'], // should be given as array to accept multiple conditons to check
    flowId: '711549ec-6604-47be-8bd0-52bf603d4fde'
  }
};
